import { useGet } from '../../../sharedModules/hooks/useQuery';
import { BackflowJobItem } from '../../model';

const FLAGGED_DEVICES_URL = '/backflows/backflow_job_items';

const FLAGGED_DEVICES_PARAMS = {
  'ransack[has_flags]': 'true',
};

export function useFlaggedDevices(options?: { enabled?: boolean }) {
  return useGet<{ result: BackflowJobItem[] }>({
    url: FLAGGED_DEVICES_URL,
    params: FLAGGED_DEVICES_PARAMS,
    enabled: options?.enabled,
  });
}
